define('../app/fukit/view/app.layout.view',['require','exports','module','marionette','templates'],function(require, exports, module) {
  //prettier-ignore
  var Mn        = require('marionette'),
      Templates = require('templates');

  var MainLayout = Mn.LayoutView.extend({
    template: function() {
      return Templates.App['app.layout'];
    },

    regions: {
      a11yAnnouncements: '#app-a11y-announcements',
      header: '#app-header',
      tasklist: '#app-tasklist',
      content: '#app-content',
      overlay: '#app-overlay',
      dimmer: '#app-dimmer',
      notifications: '#app-notifications',
    },

    ui: {
      content: '#app-content',
    },
  });

  module.exports = MainLayout;
});

